import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import { spacing } from '@vfuk/core-mixins'
import { DividerStyles } from '@vfuk/core-divider'

export const PartnerInfoWrapper = styled.div(
  (): FlattenSimpleInterpolation => css`
    display: flex;
    justify-content: center;
    align-items: center;
    ${spacing('gap', 4)}
    ${spacing('margin-bottom', 8)}
  `,
)

export const PartnerLogo = styled.div(
  (): FlattenSimpleInterpolation => css`
    img {
      max-width: 40px;
      max-height: 40px;
      object-fit: cover;
    }
  `,
)

export const DividerWrapper = styled.div(
  (): FlattenSimpleInterpolation => css`
    ${DividerStyles.Divider} {
      height: 40px;
    }
  `,
)
